import React from 'react';
import Str from '../../../helpers/Str';
import { useProcessFormWizard } from '../../../contexts/processFormWizardContext';

export interface FormProps {
  onSubmit: React.FormEventHandler<HTMLFormElement>;
  className?: string;
  children?: React.ReactNode;
}

export default function Form({
  onSubmit,
  children,
  className,
  ...rest
}: FormProps) {
  const { isAdmin } = useProcessFormWizard();

  function handleSubmit(e: any) {
    e.preventDefault();
    if (onSubmit) onSubmit(e);
  }

  return (
    <form {...rest} className={Str.tw(className)} onSubmit={handleSubmit} noValidate={isAdmin}>
      {children}
    </form>
  );
}
